import { render, staticRenderFns } from "./VueModal.vue?vue&type=template&id=3ca130ce&scoped=true&"
import script from "./VueModal.vue?vue&type=script&lang=js&"
export * from "./VueModal.vue?vue&type=script&lang=js&"
import style0 from "./VueModal.vue?vue&type=style&index=0&id=3ca130ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca130ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ca130ce')) {
      api.createRecord('3ca130ce', component.options)
    } else {
      api.reload('3ca130ce', component.options)
    }
    module.hot.accept("./VueModal.vue?vue&type=template&id=3ca130ce&scoped=true&", function () {
      api.rerender('3ca130ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/VueModal.vue"
export default component.exports